import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { readFromFBDB } from "../../services/fbdb.data";

const initialState = {
    username: null,
    email:null,
    isUserFromShopify: false,
    state: 'idle',
    error: null,
    userStatus: {},
    accountInfo:{},
}


export const graphStatus = createAsyncThunk(
    "auth/status",
    async (user, { rejectWithValue }) => {
      try {
        const dbpath = `${user}/graph-status`;
        const response = await readFromFBDB(dbpath);
        return response.data;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);
  
export const fetchUserAccountInfo = createAsyncThunk(
  "userDesigns/account",
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-account-info`;
      const response = await readFromFBDB(dbpath);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers:  {
        setLogInUser: (state, action) => {

          // let temp_username = action.payload || null;
          // if(temp_username && temp_username.includes("_prod")){
          //   temp_username = temp_username.split("_prod")[0];
          //   temp_username+= "-prod@causalfunnel.com";
          // }
          state.email = action.payload;
          state.username = action.payload;
        },
        setUserFromShopify: (state, action) => {
            state.isUserFromShopify = action.payload;
        },
        resetAuthSlice: (state,action) => {
          return { ...initialState };
      },
        setCheckoutLabel: (state, action) => {
            state.accountInfo.checkoutLabel = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
          .addCase(graphStatus.pending, (state) => {
            state.status = "loading";
          })
          .addCase(graphStatus.fulfilled, (state, action) => {
            state.status = "idle";
            state.error = null;
            state.userStatus = action.payload;
          })
          .addCase(graphStatus.rejected, (state, action) => {
            state.status = "idle";
            state.error = action.payload?.error;
          })
          .addCase(fetchUserAccountInfo.pending, (state) => {
            state.status = "loading";
          })
          .addCase(fetchUserAccountInfo.fulfilled, (state, action) => {
            state.status = "idle";
            state.accountInfo = action.payload;
            state.accountInfo.websiteURL = action.payload?.website;
          })
          .addCase(fetchUserAccountInfo.rejected, (state, action) => {
            state.status = "idle";
            state.error = action.payload?.error;
          })
      },
    
})

export const { setLogInUser,setUserFromShopify,resetAuthSlice,setCheckoutLabel } = authSlice.actions;

export const selectLogInUsername = (state) => state.auth.username;
export const selectIsUserFromShopify =  (state) => state.auth.isUserFromShopify
export const selectUserStatus =  (state) => state.auth.userStatus
export const SelectUserWebsiteURL = (state) => state.auth.accountInfo.websiteURL;
export const SelectUserAccountInfo = (state) => state.auth.accountInfo;
export const SelectUserEmail = (state) => state.auth.email;

export default authSlice.reducer;